import { render, staticRenderFns } from "./Create-Lead.vue?vue&type=template&id=2d0efc34&scoped=true"
import script from "./Create-Lead.vue?vue&type=script&lang=js"
export * from "./Create-Lead.vue?vue&type=script&lang=js"
import style0 from "./Create-Lead.vue?vue&type=style&index=0&id=2d0efc34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0efc34",
  null
  
)

export default component.exports